var render = function render(){var _vm=this,_c=_vm._self._c;return _c('time-picker',{attrs:{"controls":false,"disabled":_vm.isDisabled},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }